import { render, staticRenderFns } from "./code-redeem.vue?vue&type=template&id=349c9d6c&"
import script from "./code-redeem.vue?vue&type=script&lang=js&"
export * from "./code-redeem.vue?vue&type=script&lang=js&"
import style0 from "./code-redeem.vue?vue&type=style&index=0&id=349c9d6c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports